import { SlicePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { DevicesManagerService } from '../../../services/devices-manager.service';
import { PermissionService } from '../../../services/permission.service';
import { DEVICES_LOCKED } from '../../devices/devices-routing.constants';
import { DeviceCardComponent } from '../../shared/card/device-card/device-card.component';

@Component({
  selector: 'widget-locked-device',
  templateUrl: './widget-locked-device.component.html',
  styleUrls: ['./widget-locked-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, TranslatePipe, SlicePipe, DeviceCardComponent, MatTooltipModule],
})
export class WidgetLockedDeviceComponent {
  public permissionService = inject(PermissionService);
  private _devicesManagerService = inject(DevicesManagerService);
  private _router = inject(Router);
  public $locked = this._devicesManagerService.$locked;

  goTo() {
    this._router.navigate([DEVICES_LOCKED]);
  }
}
